import React from "react";

const ImagePlayVideo = () => {
	return (
		<svg
			className="image-play-video"
			width="100"
			height="100"
			viewBox="0 0 100 100"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g fill="none" fillRule="evenodd">
				<circle className="circle" fill="#4A545C" cx="48.5" cy="48.5" r="48.5" />
				<path className="triangle" fill="#FFF" d="m39 33 26 16-26 16z" />
			</g>
		</svg>
	);
};

export default ImagePlayVideo;
